const translation = {
  custom: 'Personalização',
  upgradeTip: {
    prefix: 'Atualize seu plano para',
    suffix: 'personalizar sua marca.',
    title: 'Atualize seu plano',
    des: 'Atualize seu plano para personalizar sua marca',
  },
  webapp: {
    title: 'Personalizar marca do web app',
    removeBrand: 'Remover Powered by Dify',
    changeLogo: 'Alterar Imagem da Marca Powered by',
    changeLogoTip: 'Formato SVG ou PNG com tamanho mínimo de 40x40px',
  },
  app: {
    title: 'Personalizar cabeçalho do aplicativo',
    changeLogoTip: 'Formato SVG ou PNG com tamanho mínimo de 80x80px',
  },
  upload: 'Enviar',
  uploading: 'Enviando',
  uploadedFail: 'Falha no envio da imagem, por favor, envie novamente.',
  change: 'Alterar',
  apply: 'Aplicar',
  restore: 'Restaurar Padrões',
  customize: {
    contactUs: ' entre em contato conosco ',
    prefix: 'Para personalizar o logotipo da marca dentro do aplicativo, por favor',
    suffix: 'para fazer upgrade para a edição Enterprise.',
  },
}

export default translation
